import * as React from 'react';
import { Base as BaseField } from './Base';
import { FieldProps, FieldRenderProps } from 'react-final-form';
import { ComponentProps } from 'react';

type OriginBaseProps<VAL = any> = Omit<
  ComponentProps<typeof BaseField>,
  keyof FieldProps<VAL, FieldRenderProps<VAL, HTMLElement>>
> &
  Partial<
    Omit<
      FieldProps<VAL, FieldRenderProps<VAL, HTMLElement>, HTMLElement>,
      'component'
    >
  > & {
    name: string;
    input: React.ComponentType<FieldRenderProps<VAL, HTMLElement>>;
    label: React.ReactNode;
  };

export const Base = React.memo((props: OriginBaseProps<{}>) => (
  <BaseField {...props} />
));

export { String } from './String';
export { Checkbox } from './Checkbox';
export { DateField as Date } from './Date';
export { DateTime as DateTime } from './DateTime';
export { TimePicker } from './TimePicker';
export { Autocomplete } from './Autocomplete';
export { ApiAutocomplete } from './ApiAutocomplete';
export { MultiSelectField as MultiSelectFilter } from './MultiSelectField';
export { DateRange } from './DateRange';
export { Number } from './Number';
export { TextArea } from './TextArea';
export { CurrencyNumber } from './CurrencyNumber';
export { MaskNumber } from './MaskNumber';